import React from "react";
import Img1 from "./images/allimages/8.webp";
import Img2 from "./images/allimages/2.webp";
import Img3 from "./images/allimages/4.webp";
import lined from "./images/hero/lined.png";
import Logo from "./images/logo.png";
import "./css/aboutus.css";

import { Link } from "react-router-dom";
import { useLanguage } from '../contexts/LanguageContext';
import { useContent } from '../contexts/ContentContext';

const Aboutus = () => {
  const { language } = useLanguage();
  const { content } = useContent();
  
  const title = content?.about 
    ? (language === 'ar' ? content.about.title_ar : content.about.title_en)
    : (language === 'ar' ? 'من نحن' : 'About Us');
  
  const companyName = content?.about
    ? (language === 'ar' ? content.about.company_name_ar : content.about.company_name_en)
    : (language === 'ar' ? 'مؤسسة عبد الله عيد الحتير شي ACPCA' : 'Abdullah Eid Al-Hatirshi Company');
  
  const description1 = content?.about?.description1_ar && content?.about?.description1_en
    ? (language === 'ar' ? content.about.description1_ar : content.about.description1_en)
    : '';
  
  const description2 = content?.about?.description2_ar && content?.about?.description2_en
    ? (language === 'ar' ? content.about.description2_ar : content.about.description2_en)
    : '';
  
  const learnMore = content?.about
    ? (language === 'ar' ? content.about.learn_more_ar : content.about.learn_more_en)
    : (language === 'ar' ? 'هل تريد معرفة المزيد عنا ؟' : 'Do you want to know more about us?');
  
  const values = content?.aboutValues || [];
  const getImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    const baseUrl = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'https://server.acpca.net';
    return `${baseUrl}${url.startsWith('/') ? url : `/${url}`}`;
  };
  
  const aboutImg1 = content?.about?.image1_url ? getImageUrl(content.about.image1_url) : Img1;
  const aboutImg2 = content?.about?.image2_url ? getImageUrl(content.about.image2_url) : Img2;
  const aboutImg3 = content?.about?.image3_url ? getImageUrl(content.about.image3_url) : Img3;
  const aboutLogo = content?.about?.logo_url ? getImageUrl(content.about.logo_url) : Logo;

  return (
    <section className="aboutus">
      <img src={lined} alt="aboutus" className="lined" />
      <div className="container">
        <div className="title">
          <h1>{title}</h1>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="images">
              <img src={aboutLogo} alt="logo" className="logo" />

              <img src={aboutImg1} alt="aboutus" className="img1" />
              <img src={aboutImg2} alt="aboutus" className="img2" />
              <img src={aboutImg3} alt="aboutus" className="img3" />
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="text">
              <h5></h5>
              <h1>{companyName}</h1>

              {description1 && <p>{description1}</p>}
              {description2 && <p>{description2}</p>}

              <ul>
                {values.length > 0 ? (
                  values.map((value, index) => (
                    <li key={value.id || index}>
                      {language === 'ar' ? value.value_ar : value.value_en}
                    </li>
                  ))
                ) : (
                  // Fallback values
                  language === 'ar' ? (
                    <>
                      <li>نحن نفعل ما نقوله</li>
                      <li>نقدم عملا عالى الجودة</li>
                      <li>نسعى إلى إيجاد أدوات وتقنيات وتكنولوجيات جديدة</li>
                      <li>نحن صادق ون وشفافون</li>
                    </>
                  ) : (
                    <>
                      <li>We do what we say</li>
                      <li>We provide high quality work</li>
                      <li>We seek to find new tools, techniques and technologies</li>
                      <li>We are honest and transparent</li>
                    </>
                  )
                )}
              </ul>

              <Link to="/about">{learnMore}</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Aboutus;
